import clsx from 'clsx';

import { Icon } from '@/components/ui/Icon';

import styles from './RepairStatusStepper.module.scss';

export interface RepairStatusStep {
  label: string;
  dateLabel?: string;
}

interface RepairStatusStepperProps {
  steps: RepairStatusStep[];
  activeIndex: number;
}

export function RepairStatusStepper({ steps, activeIndex }: Readonly<RepairStatusStepperProps>) {
  return (
    <ol className={styles.steps} data-testid="RepairStatusStepper">
      {steps.map((step, index) => {
        const isCompleted = index < activeIndex;
        const isCurrent = index === activeIndex;

        return (
          <li
            key={`${step.label}-${index}`}
            className={clsx(
              styles.step,
              isCompleted && styles.completed,
              isCurrent && styles.current
            )}
            aria-current={isCurrent ? 'step' : undefined}
            data-testid={`RepairStatusStepper-step-${index}`}
          >
            <span className={styles.node} aria-hidden="true">
              {isCompleted ? <Icon name="check" size={14} /> : null}
            </span>
            <span className={styles.label}>{step.label}</span>
            {step.dateLabel ? <span className={styles.date}>{step.dateLabel}</span> : null}
          </li>
        );
      })}
    </ol>
  );
}
